import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";
import ForumPostCard from "./ForumPostCard";
import { Flame } from "lucide-react";

export default function ForumPreview() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await supabase
        .from("forum_posts")
        .select("*, author:profiles!user_id(id,name,avatar_url,participant_id)")
        .order("upvotes", { ascending: false })
        .limit(3);
      setPosts(data || []);
      setLoading(false);
    })();
  }, []);

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <div className="flex items-baseline justify-between gap-4 flex-wrap mb-8">
        <div>
          <div className="font-hand text-marker-red text-2xl rotate-[1deg] mb-1">— community chatter —</div>
          <h2 className="font-display font-extrabold text-4xl uppercase tracking-tight flex items-center gap-2">
            Hot off the <span className="highlight-marker px-1 ml-1">Forum</span> <Flame className="text-marker-red" size={32} />
          </h2>
        </div>
        <Link to="/forum" className="brutal-btn">View all discussions →</Link>
      </div>

      <div className="space-y-4">
        {loading ? (
          <div className="brutal-card p-6 font-hand text-2xl">loading forum posts…</div>
        ) : (
          posts.map((p) => <ForumPostCard key={p.id} post={p} />)
        )}
      </div>
    </section>
  );
}
